import React from 'react'
import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Button from 'srcReact/components/common2/Button'
import { formatDate, getDateFormat2, getTimeFormat2 } from 'srcReact/helpers/datetimeHelper'
import { useDispatch } from 'react-redux'
import { rsvpActions } from '../RSVP/actions'
import { useTranslation } from 'react-i18next'
import { isMobileScreen } from 'srcReact/helpers/utils'

function MixrCardApprove({
  mixrId,
  mixrName,
  groupId,
  groupName,
  picture,
  className,
  infiniteScrollRef,
  cardType = 'mixr invitation',
  datetime,
  isMobile
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const handleAccept = () => {
    dispatch(rsvpActions.updateAttendance(mixrId, 'in_person'))
  }

  const handleDecline = () => {
    dispatch(rsvpActions.rejectInvitation(mixrId))
  }
  return (
    <div className={`${styles.mixrCardWrapper} ${className}`}>
      <article ref={infiniteScrollRef} className={`${styles.verticalCard}`}>
        <header className={styles.header}>
          <p className={styles.cardType}>{cardType}</p>
          <AnchorLink className={styles.groupLink} path={`/0/home/group/${groupId}`} backNavigation={true}>
            {groupName}
          </AnchorLink>
        </header>
        <section className={styles.body}>
          {!isMobile && (
            <figure>
              {picture ? (
                <img src={picture} alt={mixrName} className={styles.image} />
              ) : (
                <img
                  src={require('../../../assets/images/background-default-mixr.jpg')}
                  alt={mixrName}
                  className={styles.image}
                />
              )}
            </figure>
          )}

          <div className={styles.data}>
            <h3 className={styles.mixrName}> {mixrName}</h3>
            <p className={styles.datetime}>
              {`${t('formlabel.date')}: `}
              <span>{formatDate(datetime, getDateFormat2())}</span>
            </p>
            <p className={styles.datetime}>
              {`${t('formlabel.time')}: `}
              <span>{formatDate(datetime, getTimeFormat2())}</span>
            </p>
          </div>
        </section>
        <footer className={styles.footerButtons}>
          <Button
            size={isMobile ? 'small' : 'medium'}
            text={t('global.decline')}
            style='secondary'
            handleClick={handleDecline}
          />
          <Button size={isMobile ? 'small' : 'medium'} text={t('global.accept')} handleClick={handleAccept} />
        </footer>
      </article>
    </div>
  )
}

export default MixrCardApprove
